export default __webpack_public_path__ + "static/media/modal_whiteHoodieBoy.83cad415.png";